import { Children, cloneElement, isValidElement } from 'react';
function isFragment(node) {
    return (isValidElement(node) &&
        node.type ===
            Symbol.for('react.fragment'));
}
export function flattenChildren(children, keys = []) {
    return Children.toArray(children).reduce((acc, node, nodeIndex) => {
        if (isFragment(node)) {
            acc.push(...flattenChildren(node.props.children, keys.concat(node.key || nodeIndex)));
        }
        else {
            if (isValidElement(node)) {
                acc.push(cloneElement(node, {
                    key: keys.concat(String(node.key)).join('.'),
                }));
            }
            else if (typeof node === 'string' || typeof node === 'number') {
                acc.push(node);
            }
        }
        return acc;
    }, []);
}
//# sourceMappingURL=flattenChildren.js.map